import React from "react";

export const MicrophoneHeader = () => (
    <svg width="247" height="260" viewBox="0 0 247 260" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M68.6466 121.538C70.6022 128.836 54.088 156.29 46.7897 158.246C39.4914 160.202 25.721 145.592 23.7655 138.294C21.8099 130.996 26.141 123.494 33.4393 121.538C40.7375 119.583 66.691 114.24 68.6466 121.538Z"
            fill="#E0E5CD"
        />
        <path
            d="M162.932 108.545C172.088 99.3885 195.969 108.424 216.272 128.727C236.574 149.029 225.428 176.533 216.272 185.689C207.116 194.845 159.736 236.572 139.434 216.27C119.131 195.967 153.776 117.701 162.932 108.545Z"
            fill="#E6C9C9"
        />
        <path
            d="M46.0755 193.926C62.3542 188.982 138.204 185.609 131.166 200.964C124.128 216.318 97.3525 122.052 107.182 98.4688C102.79 104.883 85.2823 134.015 24.0702 154.781C22.139 156.695 21.5834 156.903 21.547 156.767"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M148.386 161.041C151.441 172.443 157.348 199.376 155.312 199.922C152.056 200.794 143.62 173.665 141.011 164.471C148.168 162.408 161.458 154.453 157.355 139.142C154.596 128.844 146.62 125.116 139.472 124.242M139.472 124.242C135.992 123.816 132.709 124.067 130.318 124.564C127.864 116.493 118.98 88.7609 122.97 88.9987C125.822 88.2345 133.596 111.907 133.191 118.996C132.786 126.085 104.084 96.6803 113.769 88.8479C118.791 84.7869 124.027 84.7906 126.31 86.7969C128.593 88.8032 134.651 107.335 139.472 124.242Z"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M151.246 158.676C154.417 168.883 160.898 191.441 158.958 203.746C152.959 205.789 143.081 207.773 139.863 199.26C121.882 151.705 127.596 138.826 121.568 139.132C115.54 139.438 115.484 160.402 97.9235 168.162C83.8749 174.371 46.7338 182.897 29.9193 186.384C27.3954 180.223 22.269 165.651 21.9541 156.658C17.2858 158.781 2.76378 164.855 7.67381 183.179C11.6018 197.839 26.6277 197.45 33.6497 195.423L35.4169 197.132L41.525 195.495C45.0822 210.399 54.7782 241.699 65.1047 247.661C83.6474 243.565 99.4994 237.572 91.885 228.701C84.2707 219.83 81.7982 218.747 78.6418 213.482C72.9408 215.01 72.0466 216.559 71.0938 214.632C70.3316 213.09 66.0052 205.957 63.9373 202.583L71.2671 200.619L76.1441 208.002L72.9452 209.281"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M166.15 157.931C251.244 172.708 251.479 75.5139 196.367 64.2391C133.738 51.4265 2.55491 100.2 57.2608 42.0135"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="6 6"
        />
        <path
            d="M64.0957 17.4868L69.7586 25.0341L72.2522 38.8694L76.1005 30.5865L100.714 18.1498L73.1553 24.124L88.9354 42.2552L112.331 11.814L64.0957 17.4868Z"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M167.325 23.0234C173.248 27.3986 168.037 33.1421 166.305 35.4865C164.573 37.831 158.368 36.1848 152.445 31.8096C146.522 27.4345 143.125 21.9871 144.856 19.6427C146.588 17.2982 161.403 18.6482 167.325 23.0234Z"
            fill="#C5D5E4"
        />
    </svg>
);
